import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const propTypes = {
  to: PropTypes.string,
};

const defaultProps = {
  to: null,
};

const LinkWithPreload = ({ to, ...rest }) => (
  <Link
    to={to}
      // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

LinkWithPreload.propTypes = propTypes;
LinkWithPreload.defaultProps = defaultProps;

const NavLinkWithPreload = ({ to, ...rest }) => (
  <NavLink
    to={to}
      // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

NavLinkWithPreload.propTypes = propTypes;
NavLinkWithPreload.defaultProps = defaultProps;

export { LinkWithPreload, NavLinkWithPreload };
